import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { informationHeight } from "contexts/Informations/Information";

export type Information = {
  title: string | React.ReactNode;
  description?: string | React.ReactNode;
  enableClose?: boolean;
  type: "info" | "warn";
  autoHideDuration?: number;
  id: string;
  order?: number;
};

export interface State {
  informations: Information[];
}

const initialState: State = {
  informations: [],
};

export const informationsSlice = createSlice({
  name: "informations",
  initialState,
  reducers: {
    pushInformation: (state, action: PayloadAction<Information>) => {
      const isAlreadyInList = state.informations.some(
        (information) => information.id === action.payload.id,
      );
      if (isAlreadyInList) return;

      state.informations = [...state.informations, action.payload];
    },
    removeInformation: (state, action: PayloadAction<Information>) => {
      state.informations = state.informations.filter(
        (information) => information.id !== action.payload.id,
      );
    },
    clearInformations: (state) => {
      state.informations = [];
    },
  },
});

export const { pushInformation, removeInformation, clearInformations } =
  informationsSlice.actions;

export const selectInformations = (state: RootState) =>
  state.informations.informations;

export const selectInformationsHeight = (state: RootState) =>
  state.informations.informations.length * informationHeight;

export default informationsSlice.reducer;
